import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { adminDashboardDetailsApi } from "../../../utils/ApiEndpointFunctions";
import Spinwheel from "../../common/Spinwheel";
import { useAdminContext } from "../../../context/adminContext";
import { useNavigate } from "react-router-dom";
import MetricCard from "./components/MetricCard";
import BusinessChart from "./components/BusinessChart";

export default function YiinoBusinessDashboard() {
  const [loader, setLoader] = useState(false)
  const [details, setDetails] = useState({})
  const { setAdminDetail, adminDetail } = useAdminContext();
  const navigate = useNavigate()

  const getDashboardDetails = async () => {
    try {
      setLoader(true);
      const res = await adminDashboardDetailsApi();
      setDetails(res?.data?.data);
      setLoader(false);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      setLoader(false);
    }
  }

  // useEffect(() => {
  //   if (adminDetail?.role === "superAdmin") {
  //     getDashboardDetails();
  //   } else {
  //     navigate("/partners?type=all")
  //   }

  // }, [adminDetail?.role])

  const topMetrics = [
    {
      label: "Total Rides",
      value: '721k',
      background: "#FECD2B",
    },
    {
      label: "Total Cost",
      value: '721k',
      background: "#448DEF",
    },
    {
      label: "Total Earning",
      value: '721k',
      background: "#E3F5FF",
    }
  ]



  const bottomMetrics = [
    {
      label: "Total Events",
      value: '721k',
      background: "#95A4FC",
    },
    {
      label: "Total Vouchers",
      value: '721k',
      background: "#00B092",
    },
    {
      label: "Total Vouchers Used",
      value: '721k',
      background: "#F68633",
    },
    {
      label: "Total Vouchers Unused",
      value: '721k',
      background: "#007965",
    }
  ]




  return (
    <>
      <div className="main-content">

        <div className="container-fluid ">
          {
            loader ? <Spinwheel /> :
              <>
                <div className="mt-2 g-4 card rounded-2">
                  <div className="metric_row">

                    {topMetrics.map((metric, index) => (
                      <MetricCard
                        width={320}
                        labelFontSize="25px"
                        valueFontSize="35px"
                        key={index}
                        label={metric.label}
                        value={metric.value}
                        background={metric.background}
                      />
                    ))}

                  </div>

                  <div className="row">
                    <BusinessChart />
                  </div>

                  <div className="metric_row">

                    {bottomMetrics.map((metric, index) => (
                      <MetricCard
                        width={270}
                        labelFontSize="15px"
                        valueFontSize="25px"
                        textColor="#fff"
                        key={index}
                        label={metric.label}
                        value={metric.value}
                        background={metric.background}
                      />
                    ))}

                  </div>
                </div>
              </>
          }

        </div>
      </div>
    </>
  );
}
